export default {"src":"/_next/static/media/SortArrow.7db03499.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};